import React from "react";
import { connect } from "react-redux";
import { useTranslation } from "react-i18next";
import FeedbackModal from "../feedback/FeedbackModal";
import { setShowEmailConfirmModal } from "../specsheet/specsheet.redux";

const ModalEmailConfirmationRedux = ({
  setShowEmailConfirmModal,
  showEmailConfirmModal,
  email,
}) => {
  const { t } = useTranslation();

  const message = (
    <div style={{ textAlign: "center" }}>
      <div style={{ fontWeight: 600 }}>
        {t("form.label.email_sent_successfully_to")}: {email}
      </div>
      <div style={{ marginTop: 10 }}>
        {t("form.label.please_allow_a_few_minutes_for_delivery")}
      </div>
    </div>
  );

  return (
    <FeedbackModal
      show={showEmailConfirmModal}
      onHide={() =>
        setShowEmailConfirmModal({ showEmailConfirmModal: false })
      }
      severity="success"
      title={t("form.label.email_sent")}
      message={message}
    />
  );
};

export const ModalEmailConfirmation = connect(
  (state) => ({
    email: state.bowlers.selectedCustomer?.email,
    showEmailConfirmModal: state.specsheet.showEmailConfirmModal,
  }),
  { setShowEmailConfirmModal },
)(ModalEmailConfirmationRedux);
